import React from 'react';
import styled from 'styled-components';
import { PrimaryButton } from 'components';
import { Product } from 'types/Product';
import './weddingBundles.css';
import { getBundleProductPricingData } from 'helpers/products';

const AddToCartButton = styled(PrimaryButton)`
    width: 50%;
    height: 40px;
    min-width: 120px;
    text-transform: uppercase;
    border-radius: 0;
    font-family: 'proxima-nova', 'Century Gothic', CenturyGothic, AppleGothic, sans-serif;
    line-height: 36px;
    letter-spacing: 0.125em;
    font-size: 0.6875rem;
    margin-top: 2em;
    padding-bottom: 5px;
    padding-top: 5px;
`;

interface BundleProductShortDescriptionProps {
  product: Product;
  onAddToCart: () => void;
}

export const BundleProductShortDescription = ({
  product,
  onAddToCart
}: BundleProductShortDescriptionProps): JSX.Element => {
  const pricingData = getBundleProductPricingData(product.shortDescription);

  if (!pricingData) {
    return null;
  }

  return (
    <div className="short-description-container">
      <img
        src={product.image}
        loading="lazy"
        width="600"
        height="600"
        alt={product.metaTitle}
      />
      <h3 className="product-title">{product.name}</h3>
      <div className="short-description" dangerouslySetInnerHTML={{ __html: product.shortDescription }}/>
      <BundlePrice productPricingData={pricingData}/>
      <div>
        <AddToCartButton onClick={onAddToCart}>Add to Cart</AddToCartButton>
        <a className="learn-more" href={`#${product.sku}_info`}>
          LEARN MORE
        </a>
      </div>
    </div>
  );
};

interface BundlePriceProps {
  productPricingData: {
    total: string;
    discount: number;
    discountedTotal: string;
    savings: string;
  };
}

const BundlePrice = ({ productPricingData }: BundlePriceProps): JSX.Element => {
  return (
    <div className="price-block">
      <div className="prices">
        <span className="original-price">{productPricingData.total}</span>
        <span>{productPricingData.discountedTotal}</span>
      </div>
      <div>
        <span className="discount">{productPricingData.discount}% off package</span>
        <span className="savings">({productPricingData.savings} Total Savings)</span>
      </div>
    </div>
  );
};